if (!customElements.get('recipient-form')) {
    customElements.define(
      'recipient-form',
      class RecipientForm extends HTMLElement {
        constructor() {
          super();
          this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
          this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
          this.checkboxInput.disabled = false;
          this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
          this.hiddenControlField.disabled = true;
          this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
          this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
          this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
          this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
          this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
          if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
  
          this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
          this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
          this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
          this.defaultErrorHeader = this.errorMessage?.innerText;
          this.currentProductVariantId = this.dataset.productVariantId;
          this.recipientFieldsContainer = this.querySelector('.recipient-fields');
          this.hideDetailsButton = this.querySelector('[data-hide-recipient-fields]');
          this.closeButton = this.querySelector('.recipient-close-button');
          
          this.addEventListener('change', this.onChange.bind(this));
          
          // Add click handler for hide details button
          if (this.hideDetailsButton) {
            this.hideDetailsButton.addEventListener('click', this.onToggleDetails.bind(this));
          }
          
          // Add click handler for close button
          if (this.closeButton) {
            this.closeButton.addEventListener('click', this.onCloseButtonClick.bind(this));
          }
          
          // Add click handler for overlay on mobile
          if (window.innerWidth <= 767) {
            document.body.addEventListener('click', this.onOverlayClick.bind(this));
          }
          
          this.onChange();
        }
  
        cartUpdateUnsubscriber = undefined;
        variantChangeUnsubscriber = undefined;
        cartErrorUnsubscriber = undefined;
  
        connectedCallback() {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
              this.resetRecipientForm();
            }
          });
  
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId === this.dataset.sectionId) {
              this.currentProductVariantId = event.data.variant.id.toString();
            }
          });
  
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
            if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
              this.displayErrorMessage(event.message, event.errors);
            }
          });
        }
  
        disconnectedCallback() {
          if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
          }
  
          if (this.variantChangeUnsubscriber) {
            this.variantChangeUnsubscriber();
          }
  
          if (this.cartErrorUnsubscriber) {
            this.cartErrorUnsubscriber();
          }
        }
  
        onCloseButtonClick(event) {
          event.preventDefault();
          this.hideRecipientFields();
          this.hideDetailsButton.innerText = 'Show details';
          this.hideDetailsButton.setAttribute('aria-label', 'Show gift card recipient fields');
          // Check if required fields are filled
          const requiredFieldsFilled = this.emailInput.value.trim() !== '' && this.nameInput.value.trim() !== '';
          if (!requiredFieldsFilled) {
            this.checkboxInput.checked = false;
          }
        }

        onOverlayClick(event) {
          // Check if clicking on the overlay (body::after)
          if (window.innerWidth <= 767 && 
              document.body.classList.contains('open-recipient-form') &&
              !this.recipientFieldsContainer.contains(event.target) &&
              !this.checkboxInput.contains(event.target) &&
              !event.target.closest('.recipient-checkbox-wrapper')) {
            this.hideRecipientFields();
            this.hideDetailsButton.innerText = 'Show details';
            this.hideDetailsButton.setAttribute('aria-label', 'Show gift card recipient fields');
            // Check if required fields are filled
            const requiredFieldsFilled = this.emailInput.value.trim() !== '' && this.nameInput.value.trim() !== '';
            if (!requiredFieldsFilled) {
              this.checkboxInput.checked = false;
            }
          }
        }

        onChange() {
          if (this.checkboxInput.checked) {
            this.enableInputFields();
            this.showRecipientFields();
            this.hideDetailsButton.innerText = 'Hide details';
            this.hideDetailsButton.setAttribute('aria-label', 'Hide gift card recipient fields');
            this.hideDetailsButton.style.display = 'inline-block';
            if (this.recipientFieldsLiveRegion) {
              this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings?.recipientFormExpanded || '';
            }
          } else {
            this.clearInputFields();
            this.disableInputFields();
            this.hideRecipientFields();
            this.hideDetailsButton.style.display = 'none';
            this.clearErrorMessage();
            if (this.recipientFieldsLiveRegion) {
              this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings?.recipientFormCollapsed || '';
            }
          }
        }
  
        onToggleDetails(event) {
          event.preventDefault();
          if (this.recipientFieldsContainer.style.display === 'block') {
            this.hideRecipientFields();
            this.hideDetailsButton.innerText = 'Show details';
            this.hideDetailsButton.setAttribute('aria-label', 'Show gift card recipient fields');
            // Check if required fields (email and name) are filled
            const requiredFieldsFilled = this.emailInput.value.trim() !== '' && this.nameInput.value.trim() !== '';
            if (!requiredFieldsFilled) {
              this.checkboxInput.checked = false;
            }
          } else {
            this.showRecipientFields();
            this.hideDetailsButton.innerText = 'Hide details';
            this.hideDetailsButton.setAttribute('aria-label', 'Hide gift card recipient fields');
          }
        }
  
        showRecipientFields() {
          if (this.recipientFieldsContainer) {
            if (window.innerWidth <= 767) {
              // Store if open_variant was active
              this.hadOpenVariant = document.body.classList.contains('open_variant');
              if (this.hadOpenVariant) {
                document.body.classList.remove('open_variant');
              }
              document.body.classList.add('open-recipient-form');
              this.recipientFieldsContainer.style.display = 'block';
              // Trigger animation after display block
              setTimeout(() => {
                this.recipientFieldsContainer.classList.add('show-fields');
              }, 10);
            } else {
              this.recipientFieldsContainer.style.display = 'block';
            }
          }
        }
  
        hideRecipientFields() {
          if (this.recipientFieldsContainer) {
            if (window.innerWidth <= 767) {
              this.recipientFieldsContainer.classList.remove('show-fields');
              document.body.classList.remove('open-recipient-form');
              // Restore open_variant if it was active before
              if (this.hadOpenVariant) {
                document.body.classList.add('open_variant');
                this.hadOpenVariant = false;
              }
              // Wait for animation to complete before hiding
              setTimeout(() => {
                this.recipientFieldsContainer.style.display = 'none';
              }, 300);
            } else {
              this.recipientFieldsContainer.style.display = 'none';
            }
          }
        }
  
        inputFields() {
          return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
        }
  
        disableableFields() {
          return [...this.inputFields(), this.offsetProperty];
        }
  
        clearInputFields() {
          this.inputFields().forEach((field) => (field.value = ''));
        }
  
        enableInputFields() {
          this.disableableFields().forEach((field) => (field.disabled = false));
        }
  
        disableInputFields() {
          this.disableableFields().forEach((field) => (field.disabled = true));
        }
  
        displayErrorMessage(title, body) {
          this.clearErrorMessage();
          this.errorMessageWrapper.hidden = false;
          if (typeof body === 'object') {
            this.errorMessage.innerText = this.defaultErrorHeader;
            return Object.entries(body).forEach(([key, value]) => {
              const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
              const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
              const message = `${value.join(', ')}`;
              const errorMessageElement = this.querySelector(`#${errorMessageId}`);
              const errorTextElement = errorMessageElement?.querySelector('.error-message');
              if (!errorTextElement) return;
  
              if (this.errorMessageList) {
                this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
              }
  
              errorTextElement.innerText = `${message}.`;
              errorMessageElement.classList.remove('d-none');
  
              const inputElement = this[`${key}Input`];
              if (!inputElement) return;
  
              inputElement.setAttribute('aria-invalid', true);
              inputElement.setAttribute('aria-describedby', errorMessageId);
            });
          }
  
          this.errorMessage.innerText = body;
        }
  
        createErrorListItem(target, message) {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.setAttribute('href', target);
          a.innerText = message;
          li.appendChild(a);
          li.className = 'error-message';
          return li;
        }
  
        clearErrorMessage() {
          this.errorMessageWrapper.hidden = true;
  
          if (this.errorMessageList) this.errorMessageList.innerHTML = '';
  
          this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
            field.classList.add('d-none');
            const textField = field.querySelector('.error-message');
            if (textField) textField.innerText = '';
          });
  
          [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
            inputElement.setAttribute('aria-invalid', false);
            inputElement.removeAttribute('aria-describedby');
          });
        }
  
        resetRecipientForm() {
          if (this.checkboxInput.checked) {
            this.checkboxInput.checked = false;
            this.clearInputFields();
            this.clearErrorMessage();
          }
        }
      }
    );
  }